//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import filterResults from '~/mixins/filter-results'

export default {
  mixins: [filterResults],
  data () {
    return {
      fetchedSoftware: false
    }
  },
  props: {
    subcategoriesAndDocuments: Array,
    productsInternalName: String
  },
  fetch () {
    this.fetchProductSoftware()
  },
  fetchOnServer: false,
  watch: {
    productsInternalName () {
      this.fetchProductSoftware()
    }
  },
  methods: {
    async fetchProductSoftware () {
      this.software = await this.$http.$get(this.$config.motecOnlineUrl + '/ResourceDownload/ResourcesForProduct?type=Software&products=' + encodeURI(this.productsInternalName))
        .then((response) => {
          this.fetchedSoftware = true
          return response
        })
        .catch((e) => {
          console.log(e.toJSON())
          this.fetchedSoftware = true
        })
    }
  }
}
